import { triggerLogout } from '@/services/auth-session';
import { clearSharedLastActivityAt } from '@/services/idle-timeout';
import TokenService from '@/services/token.service';
import publicAxios from '@/utils/public-axios';

let logoutInFlight: Promise<void> | null = null;

const revokeServerSession = async (): Promise<void> => {
    const accessToken = TokenService.getAccessToken();
    const refreshToken = TokenService.getRefreshToken();
    if (!accessToken && !refreshToken) {
        return;
    }

    const body: { accessToken?: string; refreshToken?: string } = {};
    if (accessToken) {
        body.accessToken = accessToken;
    }
    if (refreshToken) {
        body.refreshToken = refreshToken;
    }

    try {
        await publicAxios.post('auth/logout', body, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
            timeout: 10000
        });
    } catch {
        // Clear the local session even when the server is unreachable or already revoked it.
    }
};

const logoutAndClear = async (): Promise<void> => {
    await revokeServerSession();
    TokenService.clearTokens();
    clearSharedLastActivityAt();
    await triggerLogout();
};

/** Sign-out and idle timeout: revoke the server session, then return the app to the login screen. */
export const logoutSession = (): Promise<void> => {
    if (logoutInFlight) {
        return logoutInFlight;
    }

    logoutInFlight = logoutAndClear().finally(() => {
        logoutInFlight = null;
    });

    return logoutInFlight;
};
